function useUpdatedSchedulingPage(pagePath: string) {
  const isOnSchedulingPage = pagePath.startsWith('/secure/onboard/provider/') && pagePath.endsWith('/appointment')
  return isOnSchedulingPage
}

export default useUpdatedSchedulingPage
